var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContainer3BackImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_42070",
    "data-name": "Group 42070",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 297.298,
    height: 306.881,
    viewBox: "0 0 297.298 306.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6568",
    "data-name": "Path 6568",
    d: "M1459.844,146.147c0,64.767-53.04,117.271-118.468,117.271s-118.468-52.5-118.468-117.271,53.04-117.271,118.468-117.271,118.468,52.5,118.468,117.271",
    transform: "translate(-1222.908 -28.876)",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M89.415,0A89.415,89.415,0,1,0,178.83,89.415,89.415,89.415,0,0,0,89.415,0Z",
    transform: "translate(118.468)",
    fill: "#d9d9ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2520",
    "data-name": "Group 2520",
    transform: "translate(0 72.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2518",
    "data-name": "Group 2518",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6424",
    "data-name": "Path 6424",
    d: "M1183.338,733.3h30.677V702.937h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-964.94 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6425",
    "data-name": "Path 6425",
    d: "M1181.045,732.418h32.084V700.644h-32.084Zm30.174-1.905h-28.264V702.548h28.264Z",
    transform: "translate(-963.351 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6426",
    "data-name": "Path 6426",
    d: "M1281.749,733.3h30.677V702.937h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1093.539 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6427",
    "data-name": "Path 6427",
    d: "M1279.454,732.418h32.084V700.644h-32.084Zm30.174-1.905h-28.264V702.548h28.264Z",
    transform: "translate(-1091.948 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6428",
    "data-name": "Path 6428",
    d: "M1380.114,733.3h30.677V702.937h-30.677Zm.5-.5V703.435h29.671v29.371Z",
    transform: "translate(-1222.078 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6429",
    "data-name": "Path 6429",
    d: "M1377.82,732.418H1409.9V700.644H1377.82Zm30.174-1.905H1379.73V702.548h28.264Z",
    transform: "translate(-1220.488 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6430",
    "data-name": "Path 6430",
    d: "M1478.48,733.3h30.677V702.937H1478.48Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1350.618 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6431",
    "data-name": "Path 6431",
    d: "M1476.186,732.418h32.084V700.644h-32.084Zm30.173-1.905H1478.1V702.548h28.264Z",
    transform: "translate(-1349.027 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6432",
    "data-name": "Path 6432",
    d: "M1576.846,733.3h30.677V702.937h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1479.158 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6433",
    "data-name": "Path 6433",
    d: "M1574.553,732.418h32.084V700.644h-32.084Zm30.174-1.905h-28.264V702.548h28.264Z",
    transform: "translate(-1477.568 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6434",
    "data-name": "Path 6434",
    d: "M1675.462,733.3h30.677V702.937h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1608.025 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6435",
    "data-name": "Path 6435",
    d: "M1673.169,732.418h32.084V700.644h-32.084Zm30.174-1.905h-28.264V702.548h28.264Z",
    transform: "translate(-1606.435 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6436",
    "data-name": "Path 6436",
    d: "M1773.872,702.937V733.3h30.677V702.937Zm.5.5h29.671v29.371h-29.671Z",
    transform: "translate(-1736.622 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6437",
    "data-name": "Path 6437",
    d: "M1771.578,732.418h32.085V700.644h-32.085Zm30.174-1.905h-28.264V702.548h28.264Z",
    transform: "translate(-1735.032 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6438",
    "data-name": "Path 6438",
    d: "M1872.239,733.3h30.677V702.937h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1865.163 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6439",
    "data-name": "Path 6439",
    d: "M1869.944,732.418h32.084V700.644h-32.084Zm30.174-1.905h-28.264V702.548h28.264Z",
    transform: "translate(-1863.572 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6440",
    "data-name": "Path 6440",
    d: "M1970.6,733.3h30.677V702.937H1970.6Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1993.702 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6441",
    "data-name": "Path 6441",
    d: "M1968.31,732.418h32.084V700.644H1968.31Zm30.174-1.905H1970.22V702.548h28.264Z",
    transform: "translate(-1992.112 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6442",
    "data-name": "Path 6442",
    d: "M1183.338,636.315h30.677V605.948h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-964.94 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6443",
    "data-name": "Path 6443",
    d: "M1181.045,635.429h32.084V603.655h-32.084Zm30.174-1.9h-28.264V605.56h28.264Z",
    transform: "translate(-963.351 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6444",
    "data-name": "Path 6444",
    d: "M1281.749,636.315h30.677V605.948h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1093.539 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6445",
    "data-name": "Path 6445",
    d: "M1279.454,635.429h32.084V603.655h-32.084Zm30.174-1.9h-28.264V605.56h28.264Z",
    transform: "translate(-1091.948 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6446",
    "data-name": "Path 6446",
    d: "M1380.115,636.315h30.677V605.948h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1222.079 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6447",
    "data-name": "Path 6447",
    d: "M1377.82,635.429H1409.9V603.655H1377.82Zm30.174-1.9H1379.73V605.56h28.264Z",
    transform: "translate(-1220.488 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6448",
    "data-name": "Path 6448",
    d: "M1478.48,636.315h30.677V605.948H1478.48Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1350.618 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6449",
    "data-name": "Path 6449",
    d: "M1476.186,635.429h32.084V603.655h-32.084Zm30.173-1.9H1478.1V605.56h28.264Z",
    transform: "translate(-1349.027 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6450",
    "data-name": "Path 6450",
    d: "M1576.846,636.315h30.677V605.948h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1479.158 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6451",
    "data-name": "Path 6451",
    d: "M1574.553,635.429h32.084V603.655h-32.084Zm30.174-1.9h-28.264V605.56h28.264Z",
    transform: "translate(-1477.568 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6452",
    "data-name": "Path 6452",
    d: "M1675.462,636.315h30.677V605.948h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1608.025 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6453",
    "data-name": "Path 6453",
    d: "M1673.169,635.429h32.084V603.655h-32.084Zm30.174-1.9h-28.264V605.56h28.264Z",
    transform: "translate(-1606.435 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6454",
    "data-name": "Path 6454",
    d: "M1773.873,636.315h30.677V605.948h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1736.623 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6455",
    "data-name": "Path 6455",
    d: "M1771.578,635.429h32.085V603.655h-32.085Zm30.174-1.9h-28.264V605.56h28.264Z",
    transform: "translate(-1735.032 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6456",
    "data-name": "Path 6456",
    d: "M1872.239,636.315h30.677V605.948h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1865.163 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6457",
    "data-name": "Path 6457",
    d: "M1869.944,635.429h32.084V603.655h-32.084Zm30.174-1.9h-28.264V605.56h28.264Z",
    transform: "translate(-1863.572 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6458",
    "data-name": "Path 6458",
    d: "M1970.6,636.315h30.677V605.948H1970.6Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1993.702 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6459",
    "data-name": "Path 6459",
    d: "M1968.31,635.429h32.084V603.655H1968.31Zm30.174-1.9H1970.22V605.56h28.264Z",
    transform: "translate(-1992.112 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6460",
    "data-name": "Path 6460",
    d: "M1183.338,539.086h30.677V508.719h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-964.94 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6461",
    "data-name": "Path 6461",
    d: "M1181.045,538.2h32.084V506.426h-32.084Zm30.174-1.905h-28.264V508.331h28.264Z",
    transform: "translate(-963.351 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6462",
    "data-name": "Path 6462",
    d: "M1281.749,539.086h30.677V508.719h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1093.539 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6463",
    "data-name": "Path 6463",
    d: "M1279.454,538.2h32.084V506.426h-32.084Zm30.174-1.905h-28.264V508.331h28.264Z",
    transform: "translate(-1091.948 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6464",
    "data-name": "Path 6464",
    d: "M1380.115,539.086h30.677V508.719h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1222.079 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6465",
    "data-name": "Path 6465",
    d: "M1377.82,538.2H1409.9V506.426H1377.82Zm30.174-1.905H1379.73V508.331h28.264Z",
    transform: "translate(-1220.488 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6466",
    "data-name": "Path 6466",
    d: "M1478.48,539.086h30.677V508.719H1478.48Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1350.618 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6467",
    "data-name": "Path 6467",
    d: "M1476.186,538.2h32.084V506.426h-32.084Zm30.173-1.905H1478.1V508.331h28.264Z",
    transform: "translate(-1349.027 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6468",
    "data-name": "Path 6468",
    d: "M1576.846,539.086h30.677V508.719h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1479.158 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6469",
    "data-name": "Path 6469",
    d: "M1574.553,538.2h32.084V506.426h-32.084Zm30.174-1.905h-28.264V508.331h28.264Z",
    transform: "translate(-1477.568 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6470",
    "data-name": "Path 6470",
    d: "M1675.462,539.086h30.677V508.719h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1608.025 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6471",
    "data-name": "Path 6471",
    d: "M1673.169,538.2h32.084V506.426h-32.084Zm30.174-1.905h-28.264V508.331h28.264Z",
    transform: "translate(-1606.435 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6472",
    "data-name": "Path 6472",
    d: "M1773.873,539.086h30.677V508.719h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1736.623 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6473",
    "data-name": "Path 6473",
    d: "M1771.578,538.2h32.085V506.426h-32.085Zm30.174-1.905h-28.264V508.331h28.264Z",
    transform: "translate(-1735.032 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6474",
    "data-name": "Path 6474",
    d: "M1872.239,539.086h30.677V508.719h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1865.163 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6475",
    "data-name": "Path 6475",
    d: "M1869.944,538.2h32.084V506.426h-32.084Zm30.174-1.905h-28.264V508.331h28.264Z",
    transform: "translate(-1863.572 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6476",
    "data-name": "Path 6476",
    d: "M1970.6,539.086h30.677V508.719H1970.6Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1993.702 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6477",
    "data-name": "Path 6477",
    d: "M1968.31,538.2h32.084V506.426H1968.31Zm30.174-1.905H1970.22V508.331h28.264Z",
    transform: "translate(-1992.112 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6478",
    "data-name": "Path 6478",
    d: "M1183.338,442.1h30.677V411.731h-30.677Zm.5-29.869h29.671V441.6h-29.671Z",
    transform: "translate(-964.94 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6479",
    "data-name": "Path 6479",
    d: "M1181.045,441.211h32.084V409.437h-32.084Zm30.174-1.905h-28.264V411.342h28.264Z",
    transform: "translate(-963.351 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6480",
    "data-name": "Path 6480",
    d: "M1281.749,442.1h30.677V411.731h-30.677Zm.5-29.869h29.671V441.6h-29.671Z",
    transform: "translate(-1093.539 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6481",
    "data-name": "Path 6481",
    d: "M1279.454,441.211h32.084V409.437h-32.084Zm30.174-1.905h-28.264V411.342h28.264Z",
    transform: "translate(-1091.948 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6482",
    "data-name": "Path 6482",
    d: "M1380.115,442.1h30.677V411.731h-30.677Zm.5-29.869h29.671V441.6h-29.671Z",
    transform: "translate(-1222.079 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6483",
    "data-name": "Path 6483",
    d: "M1377.82,441.211H1409.9V409.437H1377.82Zm30.174-1.905H1379.73V411.342h28.264Z",
    transform: "translate(-1220.488 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6484",
    "data-name": "Path 6484",
    d: "M1478.48,442.1h30.677V411.731H1478.48Zm.5-29.869h29.671V441.6h-29.671Z",
    transform: "translate(-1350.618 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6485",
    "data-name": "Path 6485",
    d: "M1476.186,441.211h32.084V409.437h-32.084Zm30.173-1.905H1478.1V411.342h28.264Z",
    transform: "translate(-1349.027 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6486",
    "data-name": "Path 6486",
    d: "M1576.846,442.1h30.677V411.731h-30.677Zm.5-29.869h29.671V441.6h-29.671Z",
    transform: "translate(-1479.158 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6487",
    "data-name": "Path 6487",
    d: "M1574.553,441.211h32.084V409.437h-32.084Zm30.174-1.905h-28.264V411.342h28.264Z",
    transform: "translate(-1477.568 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6488",
    "data-name": "Path 6488",
    d: "M1675.462,442.1h30.677V411.731h-30.677Zm.5-29.869h29.671V441.6h-29.671Z",
    transform: "translate(-1608.025 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6489",
    "data-name": "Path 6489",
    d: "M1673.169,441.211h32.084V409.437h-32.084Zm30.174-1.905h-28.264V411.342h28.264Z",
    transform: "translate(-1606.435 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6490",
    "data-name": "Path 6490",
    d: "M1773.873,442.1h30.677V411.731h-30.677Zm.5-29.869h29.671V441.6h-29.671Z",
    transform: "translate(-1736.623 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6491",
    "data-name": "Path 6491",
    d: "M1771.578,441.211h32.085V409.437h-32.085Zm30.174-1.905h-28.264V411.342h28.264Z",
    transform: "translate(-1735.032 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6492",
    "data-name": "Path 6492",
    d: "M1872.239,442.1h30.677V411.731h-30.677Zm.5-29.869h29.671V441.6h-29.671Z",
    transform: "translate(-1865.163 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6493",
    "data-name": "Path 6493",
    d: "M1869.944,441.211h32.084V409.437h-32.084Zm30.174-1.905h-28.264V411.342h28.264Z",
    transform: "translate(-1863.572 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6494",
    "data-name": "Path 6494",
    d: "M1970.6,442.1h30.677V411.731H1970.6Zm.5-29.869h29.671V441.6h-29.671Z",
    transform: "translate(-1993.702 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6495",
    "data-name": "Path 6495",
    d: "M1968.31,441.211h32.084V409.437H1968.31Zm30.174-1.905H1970.22V411.342h28.264Z",
    transform: "translate(-1992.112 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6496",
    "data-name": "Path 6496",
    d: "M1183.338,344.666h30.677V314.3h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-964.94 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6497",
    "data-name": "Path 6497",
    d: "M1181.045,343.78h32.084V312.006h-32.084Zm30.174-1.905h-28.264V313.911h28.264Z",
    transform: "translate(-963.351 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6498",
    "data-name": "Path 6498",
    d: "M1281.749,344.666h30.677V314.3h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1093.539 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6499",
    "data-name": "Path 6499",
    d: "M1279.454,343.78h32.084V312.006h-32.084Zm30.174-1.905h-28.264V313.911h28.264Z",
    transform: "translate(-1091.948 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6500",
    "data-name": "Path 6500",
    d: "M1380.115,344.666h30.677V314.3h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1222.079 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6501",
    "data-name": "Path 6501",
    d: "M1377.82,343.78H1409.9V312.006H1377.82Zm30.174-1.905H1379.73V313.911h28.264Z",
    transform: "translate(-1220.488 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6502",
    "data-name": "Path 6502",
    d: "M1478.48,344.666h30.677V314.3H1478.48Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1350.618 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6503",
    "data-name": "Path 6503",
    d: "M1476.186,343.78h32.084V312.006h-32.084Zm30.173-1.905H1478.1V313.911h28.264Z",
    transform: "translate(-1349.027 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6504",
    "data-name": "Path 6504",
    d: "M1576.846,344.666h30.677V314.3h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1479.158 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6505",
    "data-name": "Path 6505",
    d: "M1574.553,343.78h32.084V312.006h-32.084Zm30.174-1.905h-28.264V313.911h28.264Z",
    transform: "translate(-1477.568 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6506",
    "data-name": "Path 6506",
    d: "M1675.462,344.666h30.677V314.3h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1608.025 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6507",
    "data-name": "Path 6507",
    d: "M1673.169,343.78h32.084V312.006h-32.084Zm30.174-1.905h-28.264V313.911h28.264Z",
    transform: "translate(-1606.435 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6508",
    "data-name": "Path 6508",
    d: "M1773.873,344.666h30.677V314.3h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1736.623 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6509",
    "data-name": "Path 6509",
    d: "M1771.578,343.78h32.085V312.006h-32.085Zm30.174-1.905h-28.264V313.911h28.264Z",
    transform: "translate(-1735.032 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6510",
    "data-name": "Path 6510",
    d: "M1872.239,344.666h30.677V314.3h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1865.163 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6511",
    "data-name": "Path 6511",
    d: "M1869.944,343.78h32.084V312.006h-32.084Zm30.174-1.905h-28.264V313.911h28.264Z",
    transform: "translate(-1863.572 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6512",
    "data-name": "Path 6512",
    d: "M1970.6,344.666h30.677V314.3H1970.6Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1993.702 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6513",
    "data-name": "Path 6513",
    d: "M1968.31,343.78h32.084V312.006H1968.31Zm30.174-1.905H1970.22V313.911h28.264Z",
    transform: "translate(-1992.112 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6514",
    "data-name": "Path 6514",
    d: "M1183.338,247.675h30.677V217.308h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-964.94 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6515",
    "data-name": "Path 6515",
    d: "M1181.045,246.787h32.084V215.013h-32.084Zm30.174-1.9h-28.264V216.918h28.264Z",
    transform: "translate(-963.351 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6516",
    "data-name": "Path 6516",
    d: "M1281.749,247.675h30.677V217.308h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1093.539 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6517",
    "data-name": "Path 6517",
    d: "M1279.454,246.787h32.084V215.013h-32.084Zm30.174-1.9h-28.264V216.918h28.264Z",
    transform: "translate(-1091.948 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6518",
    "data-name": "Path 6518",
    d: "M1380.115,247.675h30.677V217.308h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1222.079 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6519",
    "data-name": "Path 6519",
    d: "M1377.82,246.787H1409.9V215.013H1377.82Zm30.174-1.9H1379.73V216.918h28.264Z",
    transform: "translate(-1220.488 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6520",
    "data-name": "Path 6520",
    d: "M1478.48,247.675h30.677V217.308H1478.48Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1350.618 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6521",
    "data-name": "Path 6521",
    d: "M1476.186,246.787h32.084V215.013h-32.084Zm30.173-1.9H1478.1V216.918h28.264Z",
    transform: "translate(-1349.027 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6522",
    "data-name": "Path 6522",
    d: "M1576.846,247.675h30.677V217.308h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1479.158 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6523",
    "data-name": "Path 6523",
    d: "M1574.553,246.787h32.084V215.013h-32.084Zm30.174-1.9h-28.264V216.918h28.264Z",
    transform: "translate(-1477.568 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6524",
    "data-name": "Path 6524",
    d: "M1675.462,247.675h30.677V217.308h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1608.025 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6525",
    "data-name": "Path 6525",
    d: "M1673.169,246.787h32.084V215.013h-32.084Zm30.174-1.9h-28.264V216.918h28.264Z",
    transform: "translate(-1606.435 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6526",
    "data-name": "Path 6526",
    d: "M1773.873,247.675h30.677V217.308h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1736.623 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6527",
    "data-name": "Path 6527",
    d: "M1771.578,246.787h32.085V215.013h-32.085Zm30.174-1.9h-28.264V216.918h28.264Z",
    transform: "translate(-1735.032 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6528",
    "data-name": "Path 6528",
    d: "M1872.239,247.675h30.677V217.308h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1865.163 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6529",
    "data-name": "Path 6529",
    d: "M1869.944,246.787h32.084V215.013h-32.084Zm30.174-1.9h-28.264V216.918h28.264Z",
    transform: "translate(-1863.572 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6530",
    "data-name": "Path 6530",
    d: "M1970.6,247.675h30.677V217.308H1970.6Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1993.702 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6531",
    "data-name": "Path 6531",
    d: "M1968.31,246.787h32.084V215.013H1968.31Zm30.174-1.9H1970.22V216.918h28.264Z",
    transform: "translate(-1992.112 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6532",
    "data-name": "Path 6532",
    d: "M1183.338,150.449h30.677V120.082h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-964.94 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6533",
    "data-name": "Path 6533",
    d: "M1181.045,149.562h32.084V117.788h-32.084Zm30.174-1.905h-28.264V119.693h28.264Z",
    transform: "translate(-963.351 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6534",
    "data-name": "Path 6534",
    d: "M1281.749,150.449h30.677V120.082h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1093.539 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    d: "M1279.454,149.562h32.084V117.788h-32.084Zm30.174-1.905h-28.264V119.693h28.264Z",
    transform: "translate(-1091.948 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6536",
    "data-name": "Path 6536",
    d: "M1380.115,150.449h30.677V120.082h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1222.079 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6537",
    "data-name": "Path 6537",
    d: "M1377.82,149.562H1409.9V117.788H1377.82Zm30.174-1.905H1379.73V119.693h28.264Z",
    transform: "translate(-1220.488 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6538",
    "data-name": "Path 6538",
    d: "M1478.48,150.449h30.677V120.082H1478.48Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1350.618 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6539",
    "data-name": "Path 6539",
    d: "M1476.186,149.562h32.084V117.788h-32.084Zm30.173-1.905H1478.1V119.693h28.264Z",
    transform: "translate(-1349.027 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6540",
    "data-name": "Path 6540",
    d: "M1576.846,150.449h30.677V120.082h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1479.158 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6541",
    "data-name": "Path 6541",
    d: "M1574.553,149.562h32.084V117.788h-32.084Zm30.174-1.905h-28.264V119.693h28.264Z",
    transform: "translate(-1477.568 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6542",
    "data-name": "Path 6542",
    d: "M1675.462,150.449h30.677V120.082h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1608.025 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6543",
    "data-name": "Path 6543",
    d: "M1673.169,149.562h32.084V117.788h-32.084Zm30.174-1.905h-28.264V119.693h28.264Z",
    transform: "translate(-1606.435 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6544",
    "data-name": "Path 6544",
    d: "M1773.873,150.449h30.677V120.082h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1736.623 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6545",
    "data-name": "Path 6545",
    d: "M1771.578,149.562h32.085V117.788h-32.085Zm30.174-1.905h-28.264V119.693h28.264Z",
    transform: "translate(-1735.032 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6546",
    "data-name": "Path 6546",
    d: "M1872.239,150.449h30.677V120.082h-30.677Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1865.163 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M1869.944,149.562h32.084V117.788h-32.084Zm30.174-1.905h-28.264V119.693h28.264Z",
    transform: "translate(-1863.572 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M1970.6,150.449h30.677V120.082H1970.6Zm.5-29.869h29.671v29.371h-29.671Z",
    transform: "translate(-1993.702 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    d: "M1968.31,149.562h32.084V117.788H1968.31Zm30.174-1.905H1970.22V119.693h28.264Z",
    transform: "translate(-1992.112 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6550",
    "data-name": "Path 6550",
    d: "M1183.338,53.457h30.677V23.09h-30.677Zm.5-29.869h29.671V52.959h-29.671Z",
    transform: "translate(-964.94 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    d: "M1181.045,52.571h32.084V20.8h-32.084Zm30.174-1.905h-28.264V22.7h28.264Z",
    transform: "translate(-963.351 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6552",
    "data-name": "Path 6552",
    d: "M1281.749,53.457h30.677V23.09h-30.677Zm.5-29.869h29.671V52.959h-29.671Z",
    transform: "translate(-1093.539 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M1279.454,52.571h32.084V20.8h-32.084Zm30.174-1.905h-28.264V22.7h28.264Z",
    transform: "translate(-1091.948 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M1380.115,53.457h30.677V23.09h-30.677Zm.5-29.869h29.671V52.959h-29.671Z",
    transform: "translate(-1222.079 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M1377.82,52.571H1409.9V20.8H1377.82Zm30.174-1.905H1379.73V22.7h28.264Z",
    transform: "translate(-1220.488 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M1478.48,53.457h30.677V23.09H1478.48Zm.5-29.869h29.671V52.959h-29.671Z",
    transform: "translate(-1350.618 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M1476.186,52.571h32.084V20.8h-32.084Zm30.173-1.905H1478.1V22.7h28.264Z",
    transform: "translate(-1349.027 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M1576.846,53.457h30.677V23.09h-30.677Zm.5-29.869h29.671V52.959h-29.671Z",
    transform: "translate(-1479.158 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M1574.553,52.571h32.084V20.8h-32.084Zm30.174-1.905h-28.264V22.7h28.264Z",
    transform: "translate(-1477.568 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M1675.462,53.457h30.677V23.09h-30.677Zm.5-29.869h29.671V52.959h-29.671Z",
    transform: "translate(-1608.025 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M1673.169,52.571h32.084V20.8h-32.084Zm30.174-1.905h-28.264V22.7h28.264Z",
    transform: "translate(-1606.435 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M1773.873,53.457h30.677V23.09h-30.677Zm.5-29.869h29.671V52.959h-29.671Z",
    transform: "translate(-1736.623 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M1771.578,52.571h32.085V20.8h-32.085Zm30.174-1.905h-28.264V22.7h28.264Z",
    transform: "translate(-1735.032 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M1872.239,53.457h30.677V23.09h-30.677Zm.5-29.869h29.671V52.959h-29.671Z",
    transform: "translate(-1865.163 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M1869.944,52.571h32.084V20.8h-32.084Zm30.174-1.905h-28.264V22.7h28.264Z",
    transform: "translate(-1863.572 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M1970.6,53.457h30.677V23.09H1970.6Zm.5-29.869h29.671V52.959h-29.671Z",
    transform: "translate(-1993.702 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M1968.31,52.571h32.084V20.8H1968.31Zm30.174-1.905H1970.22V22.7h28.264Z",
    transform: "translate(-1992.112 -23.275)",
    fill: "#c5c5ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer3BackImg);
export default __webpack_public_path__ + "static/media/container3backImg.502ac68b979920074034bda8aa440249.svg";
export { ForwardRef as ReactComponent };